const RequiredMark = () => {
  return <span style={{ color: "red" }}>*</span>;
};

export default RequiredMark;
